import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { FaEye, FaPencilAlt } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PaymentStatusChanger from "../status-chenger/PaymentStatusChanger";
import {ability} from "../../../config/acl/ability";

const DataTable = ({ data }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const canReviewOrder = ability.can('order', 'review');

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Users Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Name", "Email", "Verify at"]],
      body: data.map((item) => [
        item.id,
        item.name,
        item.email,
        item.email_verified_at,
      ]),
    });
    doc.save("users_table.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {["id", "User","Membership","Start Date","End Date","Status","Payment methode","status Payment","Amount Paid"].map((column) => (
                <TableCell
                  key={column}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === column}
                    direction={orderBy === column ? order : "asc"}
                    onClick={() => handleSort(column)}
                  >
                    {column}
                  </TableSortLabel>
                </TableCell>
              ))}
              {/*<TableCell*/}
              {/*  align="center"*/}
              {/*  className="!text-darkTextColor whitespace-nowrap"*/}
              {/*>*/}
              {/*  Actions*/}
              {/*</TableCell>*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.user?.name}</TableCell>
                <TableCell align="center">{item?.membership?.name}</TableCell>
                <TableCell align="center">{item?.start_date}</TableCell>
                <TableCell align="center">{item?.end_date}</TableCell>
                <TableCell align="center">
                  <span
                      className={`badge text-darkTextColor ${
                          item?.status === 'active' ? "bg-[#28a745]" : "bg-[#ff6877]"
                      }`}
                  >
            {item?.status}
          </span>
                </TableCell>
                <TableCell align="center">{item?.payment_method}</TableCell>
                {(item?.payment_method === "manually" && canReviewOrder) &&
                item?.status_payment === "pending" ? (
                    <TableCell align="center">
                      <PaymentStatusChanger
                          data={item}
                      />
                    </TableCell>
                ) : (
                    <TableCell align="center">
                    <span
                        className={`badge w-24 text-darkTextColor ${
                            item?.status_payment === "paid"
                                ? "bg-[#28a745]"
                                : item?.status_payment === "pending"
                                ? "bg-[#f7cb73]"
                                : "bg-[#ff6877]"
                        }`}
                    >
                      {item?.status_payment}
                    </span>
                    </TableCell>
                )}
                <TableCell align="center">{item?.amount_paid} {item?.currency}</TableCell>
                {/*<TableCell align="center">*/}
                {/*  <div className="flex gap-x-10 text-lg items-center justify-center">*/}
                {/*    <Link*/}
                {/*      to={`/Membership-Services/Edit/${item?.id}`}*/}
                {/*      color="inherit"*/}
                {/*      underline="none"*/}
                {/*    >*/}
                {/*      <FaPencilAlt className="text-[#6c757d]" />*/}
                {/*    </Link>*/}
                {/*    /!*<Link*!/*/}
                {/*    /!*  to={`/membership-Services/${item?.id}`}*!/*/}
                {/*    /!*  color="inherit"*!/*/}
                {/*    /!*  underline="none"*!/*/}
                {/*    /!*  className="flex items-center justify-center"*!/*/}
                {/*    /!*>*!/*/}
                {/*    /!*  <FaEye className="text-[#6c757d]" />*!/*/}
                {/*    /!*</Link>*!/*/}
                {/*  </div>*/}
                {/*</TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
